import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

export type CatalogueListState = {
  scrollY: number;
  loadedCount: number;
};

/**
 * Persists catalogue list scroll and how many items were loaded across detail navigation.
 * Angular's built-in scroll restoration runs before async list content mounts,
 * so we restore manually after the catalogue finishes loading.
 */
@Injectable({
  providedIn: 'root',
})
export class CatalogueViewStateService {
  private pending: CatalogueListState | null = null;
  private latestLoadedCount = 0;

  constructor(router: Router) {
    router.events
      .pipe(filter((event): event is NavigationStart => event instanceof NavigationStart))
      .subscribe((event) => {
        const from = this.pathOnly(router.url);
        const to = this.pathOnly(event.url);
        if (from === '/templates' && this.isCatalogueChild(to)) {
          this.pending = {
            scrollY: window.scrollY || document.documentElement.scrollTop || 0,
            loadedCount: this.latestLoadedCount,
          };
        }
      });
  }

  setLoadedCount(count: number): void {
    this.latestLoadedCount = Math.max(0, count);
  }

  consumePendingState(): CatalogueListState | null {
    const state = this.pending;
    this.pending = null;
    return state;
  }

  private pathOnly(url: string): string {
    return url.split('?')[0].split('#')[0];
  }

  private isCatalogueChild(path: string): boolean {
    return path === '/templates/review' || /^\/templates\/\d+$/.test(path);
  }
}
